module.exports = __webpack_public_path__ + "static/jon-8b52a2bce3efc35679e240b01633a917.png";